import moment from "moment";

export const getBiDateByType = (type) => {

    let from = moment().format("DD.MM.YYYY");
    let to = moment().format("DD.MM.YYYY");

    switch (type) {
        case 'today':
            break;
        case 'yesterday':
            from = moment().subtract(1, 'days').format("DD.MM.YYYY");
            to = moment().subtract(1, 'days').format("DD.MM.YYYY");
            break;
        case 'week':
            from = moment().subtract(7, 'days').format("DD.MM.YYYY");
            break;
        case 'month':
            from = moment().subtract(1, 'months').format("DD.MM.YYYY");
            break;
        case 'quarter':
            from = moment().startOf('quarter').format("DD.MM.YYYY");
            break;
        case 'half_year':
            from = moment().subtract(6, 'months').format("DD.MM.YYYY");
            break;
        default:
            break;
    }

    return {
        from,
        to
    }
}